import React, { useState } from 'react';
import { toast } from 'react-toastify';
import Spinner from './Spinner';
import { reserveStock } from '../utils/api';

const StockReserve: React.FC = () => {
    const [productId, setProductId] = useState<string>('');
    const [quantity, setQuantity] = useState<number>(1);
    const [reference, setReference] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);

    const handleReserveStock = async () => {
        if (!productId.trim()) {
            toast.error("Product ID is required.");
            return;
        }

        if (quantity <= 0) {
            toast.error("Reservation quantity must be positive.");
            return;
        }

        const productIdNum = parseInt(productId, 10);
        if (isNaN(productIdNum)) {
            toast.error("Invalid Product ID.");
            return;
        }

        setLoading(true);
        try {
            const response = await reserveStock(productIdNum, quantity, reference);
            toast.success(response.message || `Successfully reserved stock for product ID ${productIdNum}.`);
            // Reset form after successful reservation
            setProductId('');
            setQuantity(1);
            setReference('');
        } catch (err: any) {
            toast.error(err.message || "Failed to reserve stock.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="bg-white p-6 rounded-lg shadow-md">
            {loading && <Spinner />}
            <div className="mb-4">
                <label htmlFor="reserveProductId" className="block text-sm font-medium text-gray-700 mb-1">Product ID</label>
                <input type="text" id="reserveProductId" value={productId} onChange={(e) => setProductId(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500" placeholder="Enter Product ID" />
            </div>
            <div className="mb-4">
                <label htmlFor="reserveQuantity" className="block text-sm font-medium text-gray-700 mb-1">Quantity to Reserve</label>
                <input type="number" id="reserveQuantity" value={quantity} onChange={(e) => setQuantity(parseInt(e.target.value, 10) || 1)} className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500" min="1" />
            </div>
            <div className="mb-6">
                <label htmlFor="reserveReference" className="block text-sm font-medium text-gray-700 mb-1">Reference (Optional)</label>
                <input type="text" id="reserveReference" value={reference} onChange={(e) => setReference(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500" placeholder="e.g., Order #123" />
            </div>
            <button onClick={handleReserveStock} disabled={loading} className="w-full bg-purple-600 hover:bg-purple-700 text-white font-bold py-2 px-4 rounded transition duration-150 disabled:opacity-50">
                {loading ? 'Processing...' : 'Reserve Stock'}
            </button>
        </div>
    );
};

export default StockReserve;

